module.exports = {"breakpoints":{"xs":0,"xs-sm":"500px","sm":"576px","md":"768px","lg":"1024px","lg-xlSm":"1140px","lg-xl":"1380px","xl":"1910px"},"colors":{"dark":"#212529","black":"#000","white":"#fff","yellow--dark":"#FF9600","yellow":"#FFD200","ping":"#FF5EB4","orange":"#FF9600","violet":"#824686","violet--dark":"#7e4697","gray--dark":"#2B2B2B","gray":"#828282","gray-light":"#BDBDBD","gray-lighten":"#E7E7E7","gray-lighter":"#F6F6F6","green":"#31C162","red":"#FF4A4A"},"spriteColors":{"blue":"#167acc","black":"black"}}


//////////////////
// WEBPACK FOOTER
// ./src/theme.json
// module id = 24
// module chunks = 0